export function getMsgReqId(msg) {
    return msg.reqId || msg?.ctx?.reqId;;
}